export default {"src":"/_next/static/media/open-door.2e6be7fb.svg","height":342,"width":337,"blurWidth":0,"blurHeight":0};